import api from '@/plugins/apiService'

export default {
  state: {
    accountDetails: false,
  },

  getters: {
    GET_ACCOUNT_DETAILS: state => state.accountDetails,
  },

  mutations: {
    SET_ACCOUNT_DETAILS: (state, payload) => {
      state.accountDetails = payload
    },
  },

  actions: {
    async UPDATE_CUSTOMER({ commit }, payload) {
      const body = {
        total: payload.total,
      }
      try {
        const { data } = await api.update(
          `ac-api/customer-licensing/update-customer/${payload.tenant_id}`,
          body,
        )
        if (data.success) {
          return data
        }
      } catch (error) {
        console.error('Error in ADD_PAYMENT_METHOD:', error)
      }
    },
  },
}
